module.exports = __webpack_public_path__ + "img/img01.9e2de897.png";